module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dialogues"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "d.r.e.a.m.s."
    }
  }, [_c('h2', [_vm._v("D.R.E.A.M.S.")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "99%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "95%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "header"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Man1:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("What’s the matter?")])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Man2:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("I had this horrible nightmare.")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Man1:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("I thought all nightmares were horrible?")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Man2:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("I am not amused. And as I was saying…")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Man1:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Hmm.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Man2:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("As I was saying, I had this nightmare about an orange and yellow fish chasing me. Sometimes it would disappear then reappear in front of me.")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Man1:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Whoa! What did it look like again?")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Man2:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Well it kinda’ looked like the giant fish kites that the Chinese use in their celebrations.")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Man1:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("And THAT is what was chasing you?")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Man2:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("It was just a dream and as a matter of fact, it was my dream and I can dream anything I want. Nobody gave you a hard time about the dream that you had with Fay Wray and King Kong. Especially the part where you were hanging…")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Man1:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Okay, that’s enough. Point taken. Did it ever catch you?")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Man2:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("No! Like all dreams, it just ended with the fish cornering me.")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Man1:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Well, I can tell you what that means?")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Man2:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("And the Great Mesmo?")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Man1:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("It means never go out with your shoes?")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Man2:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("What!")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Man1:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("That’s right. You ran out last night to the Chinese restaurant and left one at home.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Man2:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Yeah?")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Man1:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("And what did you eat?")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Man2:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Oh, no! Fish. No punch line please!")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Man1:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Sorry. But Fay Wray and King Kong comments deserve a retort.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Man2:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Go ahead!")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Man1:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("You left your SOLE at home and it was trying to catch up with you.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Man2")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Wise guy! And you?")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Man1:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Water. I can swim.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdc24252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0002.vue
// module id = 75
// module chunks = 0